import React from "react";

const ReportHomeButton = ({data, activeMainReportId, setMain}) => {

    return (<>
        {data.map((e, i) => <div
            key={i}
            onClick={() => setMain(e.id, e.name)}
            className={"h-auto select-none cursor-pointer rounded-md shadow-md hover:shadow-2xl border border-white backdrop-blur-[30px] " + (activeMainReportId === e.id ? " bg-[#163578] " : " bg-white bg-opacity-75 ")}>
            <div className={"flex flex-col p-6 gap-3"}>
                <div className={"bg-white p-5 w-fit h-14 rounded-md shadow-lg"}>
                    <img alt={e.name} src={"/images/icons/finance/icon" + (i + 1) + ".svg"}
                         className={" w-5 "}/>
                </div>
                <div><p
                    className={"text-lg font-bold leading-[21px]" + (activeMainReportId === e.id ? " text-white " : " text-slate-500 ")}>{e.name}</p>
                </div>
                <div>
                    <span
                        className={"leading-[19.18px]" + (activeMainReportId === e.id ? " text-white " : " text-slate-500 ")}
                        dangerouslySetInnerHTML={{__html: e.data}}>
                        </span>
                </div>
                <div className={"flex flex-row justify-end"}>
                    <span
                        className={"leading-[0px] text-xs" + (activeMainReportId === e.id ? " text-white " : " text-slate-500 ")}>{e.data_date}
                        </span>
                </div>
            </div>
        </div>)}

    </>)
}

export default ReportHomeButton;